export function validatePlainText(value, options) {
  options = options || {};

  if (value != null && typeof value !== 'string') {
    return { valid: false, value: '', message: options.typeMessage || '输入内容格式不正确' };
  }

  var text = String(value == null ? '' : value).trim();
  if (options.required && !text) {
    return { valid: false, value: text, message: options.requiredMessage || '请输入内容' };
  }
  if (options.maxLength && text.length > options.maxLength) {
    return { valid: false, value: text, message: options.maxLengthMessage || ('输入内容不能超过' + options.maxLength + '个字符') };
  }

  return { valid: true, value: text, message: '' };
}



// WEBPACK FOOTER //
// ./src/assets/utils/TicketInputValidator.js